export default __webpack_public_path__ + "static/media/icon_error403.58afa6f2.svg";